import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation, generatePath } from 'react-router-dom';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Button, TextField, CircularProgress, Dialog, DialogActions, 
  DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, Select, MenuItem,
  FormControlLabel, Checkbox, Tabs, Tab, Box, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import { PaginatedResponse } from '../../../shared/models';

import { API_URLS, getAllUsers, getCommodityGroups, getCustomerOrderPickGroupUsers, getCustomerOrderPickGroups, getCustomerOrders, getLocations, saveCustomerOrderPickGroup, toggleCustomerOrderFinalize, getUnfinishedCustomerOrders } from '../../api';
import composeRequest from '../../../shared/api/core';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { BusinessRouterPaths, MasterDataRouterPaths } from '../../../page/Routes/RouterPaths';
import OrderListFilterModal from '../../components/OrderListFilterModal/OrderListFilterModal.web';
import OrderExpandRowContent from '../../components/OrderExpandRowContent/OrderExpandRowContent.web';
import { saveSelectedCustomerOrder } from '../../../master-data/data/actions/customerOrderActions';
import moment from 'moment';
import { ErrorStatusBar, CustomTableTitle, ExportMenu, ExportStatusBar, ConfirmModal, } from '../../../shared/components';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG } from '../../../shared/lib/Localization';
import { initQueryParams, replaceHistory, tableOptions, useQuery } from '../../../shared/lib/TableQueryParams';
import download from 'downloadjs';

import { Filter, FilterType } from '../../../shared/models/Filter';
import { AvailableFilters, SelectedFilters, FilterRow } from '../../../products/components/Filters';
import GlobalStyles from '../../../../styles/GlobalStyles.web';
import MaterialTable, { MTableToolbar } from 'material-table';
import { getMasterCompaniesFullList } from '../../../master-data/api'
import TransferList from '../../../shared/components/TransferList/TransferList';
import { hasPermission } from '../../../shared/lib/PermissionManager';
import { Toast, ToastError, ToastSuccess, enqueueSnackbar } from '../../../shared/components/Notifier';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'left',
      justifyContent: 'left',

    },
    paper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    formControl: {
      // margin: theme.spacing(1),
      minWidth: 120,
      width: '100%',
      maxWidth: '16rem'
    },
    progress: {
      margin: theme.spacing(2),
    },

    select: {
      color: 'black',
      marginRight: 4,
      '&:before': {
        borderColor: GlobalStyles.primaryColor,
      },
      '&:after': {
        borderColor: GlobalStyles.primaryColor,
      },
      maxWidth: '15rem',
      minWidth: '12rem',
    },
    divider: {
      margin: theme.spacing(0.5, 0),
    },
  }),
);

interface OrderPickGroup {
  id ?: string
  name: string
  location: any
  commodityGroups ?: any[]

}
const ConfirmToggleFinalizeModalData = {
  isOpen: false,
  message1: 'Are you sure you want to finalize this order?',
  message2: "",
  title: 'Confirm Finalize',
  confirmBtnText: 'Yes',
  onCancel: () => { },
  onConfirm: () => { }
};

const TOGGLE_FINALIZE_ORDER = 'toggle_finalize_order'



const CustomerOrderList = (props: any) => {
  const muiTheme = useTheme();
  const isSmDown = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const [listTab, setListTab] = useState(0);
  const [unfinishedFilterQuery, setUnfinishedFilterQuery] = useState<string | null>(null);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [activeFilterBadge, setActiveFilterBadge] = useState(0);

  const resetNewLocation = () => {
    return {
      name: "",
      commodityGroups: [],
      location: ""
    }
  }
  const classes = useStyles({});
  let tableRef = useRef<{ onQueryChange: any; onChangePage: any; }>();
  let userTableRef = useRef<{ onQueryChange: any; onChangePage: any; }>();
  const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [userEmptyDataSourceMessage, setUserEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
  let locationQuery = useQuery(useLocation);
  const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
  const [userTableQuery, setUserTableQuery] = useState(initQueryParams(locationQuery));
  const [isLoading, setLoading] = useState(false);
  const [isUsersLoading, setUsersLoading] = useState(false);
  const [hasCGLoaded, sethasCGLoaded] = useState(false);
  const [isExporting, setExporting] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [allCommodityGroups, setAllCommodityGroups] = useState([]);
  const [selectedCommodityGroups, setSelectedCommodityGroups] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogBoxOpen, setDialogBoxOpen] = useState(false);
  const [userDialogBoxOpen, setUserDialogBoxOpen] = useState(false);
  const [selectedOrderPickGroup, setSelectedOrderPickGroup] = useState<OrderPickGroup>(resetNewLocation())
  const [selectedAddUser, setSelectedAddUser] = useState<any>()
  const [selectedEditUser, setSelectedEditUser] = useState<any>()
  const [selectedAddUserCanFinalize, setSelectedAddUserCanFinalize] = useState<boolean>(false)
  const [allAddUsers, setAllAddUsers] = useState<any>()
  const [userEditMode, setUserEditMode] = useState<any>()
  const [confirmToggleFinalizeModalData, setConfirmToggleFinalizeModalData] = useState(ConfirmToggleFinalizeModalData);
  const userPermissions = props.userData.userData.userData.user_permissions
  const isSuperUser = props.userData.userData.userData.is_superuser

  

  

  useEffect(() => {
    const sb = props.userData.selectedBusiness;
    

  }, [])

  const onNewOrderPickGroupClick = () => {
    setDialogBoxOpen(true);
    setSelectedOrderPickGroup(resetNewLocation())
    setSelectedCommodityGroups([])
    setSelectedUsers([])
    setAllAddUsers(allUsers)
    setUserEditMode(false)
    setSelectedEditUser(null)
  }
  const setEditOrderPickGroup = (rowData) => {
    setSelectedOrderPickGroup(rowData)
    setSelectedCommodityGroups(rowData.commodityGroups)
    setSelectedUsers(rowData.users)
    const newallAddUsers = allUsers.filter(a => {
      const found = rowData.users.find(ru => ru.user.id === a.id)
      return !found
    })
    setAllAddUsers(newallAddUsers)
    setDialogBoxOpen(true);
  }
  const handleDialogBoxCancel = () => {
    setDialogBoxOpen(false);
    setSelectedOrderPickGroup(resetNewLocation())
    setSelectedCommodityGroups([])
  }
  const handleAddUserDialogBox = () => {
    setUserDialogBoxOpen(true);
    
  }
  const handleEditUserDialogBox = (rowData) => {
    setUserDialogBoxOpen(true);
    setSelectedEditUser(rowData)
    setSelectedAddUserCanFinalize(rowData.can_finalize_order)
    setUserEditMode(true)
  }
  const handleRemoveUser = (rowData) => {
    const newUsers = selectedUsers.filter(s => s.user.id !== rowData.user.id)
    setSelectedUsers(newUsers)
    allAddUsers.push(rowData)
    setAllAddUsers([...allAddUsers])
  }
  const handleUserDialogBoxCancel = () => {
    setUserDialogBoxOpen(false);
    setSelectedAddUser(null)
    setSelectedAddUserCanFinalize(false)
    setUserEditMode(false)
    setSelectedEditUser(null)
  }
  const handleSave = () => {
    setDialogLoading(true)
    const sb = props.userData.selectedBusiness;
    let opgId = null;
    if (selectedOrderPickGroup && selectedOrderPickGroup.hasOwnProperty('id')) {
      opgId = selectedOrderPickGroup.id
    }
    const data = {...selectedOrderPickGroup}
    data['commodityGroups'] = selectedCommodityGroups
    data['business'] = sb.business_id
    data['users'] = selectedUsers
    data['location'] = selectedOrderPickGroup.location.id
    saveCustomerOrderPickGroup(data, opgId).catch(handleError) // handle network issues
    .then(checkStatus)
    .then(parseJSON)
    .then((data: any) => {
      console.log(data)
      setDialogLoading(false)
      handleDialogBoxCancel()
      if (tableRef) {
        tableRef.current.onQueryChange()
      }
    })
  }

  const handleNameChange = (e) => {
    selectedOrderPickGroup.name = e.target.value
    setSelectedOrderPickGroup({...selectedOrderPickGroup})
  }
  const handleSelectedLocationChange = (e) => {
    const locationId = e.target.value
    const location = allLocations.find(l => l.id === locationId)
    selectedOrderPickGroup.location = location
    setSelectedOrderPickGroup({...selectedOrderPickGroup})
  }
  const handleSelectedAddUser = (e) => {
    setSelectedAddUser(e.target.value)
  }

  const handleAddUser = () => {
    if (selectedUsers && !userEditMode) {
      if (selectedAddUser) {
        const existing = selectedUsers.find(s => s.user.id === selectedAddUser)
        if (existing) {
          existing.can_finalize_order = selectedAddUserCanFinalize
        } else {
          const user = allAddUsers.find(a => a.id === selectedAddUser)
          const data = {
            user: {...user},
            can_finalize_order: selectedAddUserCanFinalize,
            order_pick_group: selectedOrderPickGroup.id
          }
          selectedUsers.push(data)
        }
        setSelectedUsers([...selectedUsers])
        const newallAddUsers = allAddUsers.filter(a => a.id !== selectedAddUser)
        setAllAddUsers(newallAddUsers)
      }
    }
    if (userEditMode) {
      const existing = selectedUsers.find(s => s.user.id === selectedEditUser.user.id)
      if (existing) {
        existing.can_finalize_order = selectedAddUserCanFinalize
      } 
      setSelectedUsers([...selectedUsers])
    }
    setSelectedAddUser(null)
    setSelectedAddUserCanFinalize(false)
    setUserDialogBoxOpen(false)
  }

  const toggleFinalizeOrder = (order) => {
    const sb = props.userData.selectedBusiness;
    let location_id = props.userData.selectedLocations[0].id
    toggleCustomerOrderFinalize(order.order_id, sb.business_id,
      location_id,).then(() => {
      props.showToast({
        message: 'Successfully changed the status',
        options: ToastSuccess
      });
      if (tableRef) {
        tableRef.current.onQueryChange()
      }
    }).catch((error) => {
      console.error(error)
      props.showToast({
        message: 'Failed to change the status',
        options: ToastError
      });
    })
  }

  const navigateToPicking = (rowData: any) => {
    props.saveSelectedCustomerOrder({ item: rowData });
    const path = generatePath(BusinessRouterPaths.customerOrderPickingDetail, {
      orderId: String(rowData.order_id),
    });
    props.history.push(path);
  };

  const onUnfinishedFilterApply = (payload: {
    codeQuery: string | null;
    statusFilter: string | null;
    userFilter: string | null;
    activeCodeCount: number;
  }) => {
    let filter: string | null = null;
    if (payload.codeQuery) {
      filter = payload.codeQuery;
    }
    if (payload.statusFilter) {
      filter = filter ? filter + payload.statusFilter : payload.statusFilter;
    }
    if (payload.userFilter) {
      filter = filter ? filter + payload.userFilter : payload.userFilter;
    }
    let count = payload.activeCodeCount;
    if (payload.statusFilter) {
      count++;
    }
    if (payload.userFilter) {
      count++;
    }
    setUnfinishedFilterQuery(filter);
    setActiveFilterBadge(count);
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  };

  const confirmToggleFinalize = (order) => {
    let message = ""
    if (order.is_finalized) {
      message = "Are you sure you want to un-finalize this order?"
    } else {
      message = "Are you sure you want to finalize this order?"
    }
    setConfirmToggleFinalizeModalData({
      ...confirmToggleFinalizeModalData,
      message1: message,
      isOpen: true,
      onCancel: () => {
        setConfirmToggleFinalizeModalData({ ...confirmToggleFinalizeModalData, isOpen: false });
      },
      onConfirm: () => {
        setConfirmToggleFinalizeModalData({ ...confirmToggleFinalizeModalData, isOpen: false });
        toggleFinalizeOrder(order)
      }
    });
  };





  const sb = props.userData.selectedBusiness;
  const location_id = props.userData.selectedLocations?.[0]?.id;

  if (!sb || !location_id) {
    return (
      <div>
        <Typography variant="body1" style={{ padding: 16 }}>
          Select a business and location to view customer orders.
        </Typography>
      </div>
    );
  }

  const allOrdersColumns = [
    { title: 'Number', field: 'order_number', cellStyle: { wordBreak: 'break-word' as const } },
    {
      title: 'Net Total',
      field: 'net_total',
      render: (rowData: any) => (
        <span title={rowData.net_total != null ? String(rowData.net_total) : ''}>
          {rowData.net_total != null ? String(rowData.net_total) : '—'}
        </span>
      ),
    },
    {
      title: 'Pick Groups',
      field: 'pick_groups',
      render: (rowData: any) =>
        rowData?.pick_groups?.length
          ? rowData.pick_groups.map((p: any) => p.name).join(', ')
          : '—',
    },
    {
      title: 'Is Finalized',
      field: 'is_finalized',
      render: (rowData: any) =>
        rowData ? (
          <Checkbox
            checked={rowData.is_finalized}
            onClick={() => confirmToggleFinalize(rowData)}
            disabled={!hasPermission(userPermissions, TOGGLE_FINALIZE_ORDER, isSuperUser)}
          />
        ) : null,
    },
  ];

  const unfinishedColumns = [
    {
      title: 'Number',
      field: 'order_number',
      cellStyle: { wordBreak: 'break-word' as const, maxWidth: isSmDown ? 120 : undefined },
    },
    {
      title: 'Created',
      field: 'created_time',
      render: (row: any) => (row.created_time ? moment(row.created_time).format('YYYY/MM/DD') : '—'),
    },
    {
      title: 'Customer',
      field: 'user',
      render: (row: any) => {
        const u = row.user;
        if (!u) {
          return '—';
        }
        return `${u.first_name || ''} ${u.last_name || ''}`.trim() || '—';
      },
    },
    { title: 'Items', field: 'item_count', render: (r: any) => r.item_count ?? '—' },
    {
      title: 'Net',
      field: 'net_total',
      render: (r: any) => (r.net_total != null ? String(r.net_total) : '—'),
    },
    {
      title: 'Pick groups',
      field: 'pick_groups',
      render: (rowData: any) =>
        rowData?.pick_groups?.length
          ? rowData.pick_groups.map((p: any) => p.name).join(', ')
          : '—',
    },
  ];

  return (
    <div>
      <ErrorStatusBar isVisible={isErrorStatusVisible} />
      <ExportStatusBar isVisible={isExporting} />
      <Box px={1} pt={1}>
        <Tabs
          value={listTab}
          onChange={(_, v) => {
            setListTab(v);
            setTimeout(() => tableRef.current && tableRef.current.onQueryChange(), 0);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={
              activeFilterBadge > 0
                ? `Unfinished (picking) · ${activeFilterBadge}`
                : 'Unfinished (picking)'
            }
          />
          <Tab label="All orders" />
        </Tabs>
      </Box>
      {
        <div style={{ maxWidth: '100%' }}>
          <div className="table-wrapper">
            <MaterialTable
              key={listTab}
              options={{
                ...tableOptions(tableQuery),
                thirdSortClick: false,
                draggable: false,
                sorting: true,
                pageSize: listTab === 0 ? 20 : 20,
              }}
              tableRef={tableRef}
              localization={{
                body: {
                  emptyDataSourceMessage: emptyDataSourceMessage
                }
              }}
              columns={listTab === 0 ? unfinishedColumns : allOrdersColumns}
              detailPanel={
                listTab === 0
                  ? (rowData: any) => (
                      <OrderExpandRowContent
                        orderId={rowData.order_id}
                        businessId={sb.business_id}
                        locationId={String(location_id)}
                      />
                    )
                  : undefined
              }
              data={query =>
                new Promise((resolve) => {
                  replaceHistory(query, props.history);
                  let pageData = {
                    data: [] as any[],
                    totalCount: 0,
                    page: query.page
                  };
                  let orderBy = '';
                  if (query.orderBy) {
                    orderBy = query.orderBy.field as string;
                    orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                  }
                  setLoading(true);

                  if (listTab === 0) {
                    getUnfinishedCustomerOrders(
                      sb.business_id,
                      String(location_id),
                      unfinishedFilterQuery,
                      query.page + 1,
                      query.pageSize,
                      query.search || null,
                    )
                      .catch(handleError)
                      .then(checkStatus)
                      .then(parseJSON)
                      .then((data: PaginatedResponse<any>) => {
                        setLoading(false);
                        setErrorStatusVisible(false);
                        setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                        pageData = {
                          data: data.results,
                          totalCount: data.count,
                          page: query.page
                        };
                        setTableQuery({
                          ...tableQuery,
                          orderBy,
                          totalCount: data.count,
                          page: query.page,
                          pageSize: query.pageSize
                        });
                        resolve(pageData);
                      })
                      .catch((error: any) => {
                        console.error(error);
                        setEmptyDataSourceMessage(error?.status === 500 ? ERROR_500 : ERROR_MSG);
                        setLoading(false);
                        resolve(pageData);
                      });
                  } else {
                    getCustomerOrders(
                      sb.business_id,
                      location_id,
                      query.page + 1,
                      query.pageSize,
                      query.search,
                      orderBy
                    )
                      .catch(handleError)
                      .then(checkStatus)
                      .then(parseJSON)
                      .then((data: PaginatedResponse<any>) => {
                        setLoading(false);
                        setErrorStatusVisible(false);
                        setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                        const results = data.results;
                        pageData = {
                          data: results,
                          totalCount: data.count,
                          page: query.page
                        };
                        setTableQuery({
                          ...tableQuery,
                          orderBy,
                          totalCount: data.count,
                          page: query.page,
                          pageSize: query.pageSize
                        });
                        resolve(pageData);
                      })
                      .catch((error: any) => {
                        console.error(error);
                        if (error) {
                          if (error.status && error.status === 500) {
                            setEmptyDataSourceMessage(ERROR_500);
                            setErrorStatusVisible(false);
                          } else if (error.status === 403 || error.status === 401) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(true);
                          } else {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                          }
                        }
                        setTableQuery({
                          ...tableQuery,
                          totalCount: 0,
                          page: query.page,
                          pageSize: query.pageSize
                        });
                        setLoading(false);
                        resolve(pageData);
                      });
                  }
                })
              }
              title={
                <CustomTableTitle
                  history={props.history}
                  title={listTab === 0 ? 'Unfinished customer orders' : 'All customer orders'}
                  icon={SVG_ICONS.product} />
              }
              actions={[
                ...(listTab === 0
                  ? [
                      {
                        icon: 'filter_list',
                        tooltip: 'Filters',
                        isFreeAction: true,
                        onClick: () => setFilterModalOpen(true),
                      },
                    ]
                  : []),
                {
                  icon: 'refresh',
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                },
                ...(listTab === 0
                  ? [
                      {
                        icon: 'edit',
                        tooltip: 'Pick / edit',
                        onClick: (_e: any, rowData: any) => navigateToPicking(rowData),
                      },
                    ]
                  : []),
              ]}
            />
          </div>
        </div>
      }
      <OrderListFilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        businessId={sb.business_id}
        locationId={String(location_id)}
        onApply={onUnfinishedFilterApply}
      />
      {/* {
        
          !hasCGLoaded &&
          <div style={{ textAlign: 'center', marginTop: 5 }}>
            <CircularProgress />
          </div>
        
      } */}
      <ConfirmModal
        isOpen={confirmToggleFinalizeModalData.isOpen}
        onCancel={confirmToggleFinalizeModalData.onCancel}
        onConfirm={confirmToggleFinalizeModalData.onConfirm}
        confirmBtnText={confirmToggleFinalizeModalData.confirmBtnText}
        dialogTitle={confirmToggleFinalizeModalData.title}
        dialogMessage1={confirmToggleFinalizeModalData.message1}
        dialogMessage1Color={GlobalStyles.red}
        dialogMessage2={confirmToggleFinalizeModalData.message2}
      />
      </div>
      
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.userLocalData,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    showToast: (toast: Toast) => dispatch(enqueueSnackbar(toast)),
    saveSelectedCustomerOrder: (data: any) => dispatch(saveSelectedCustomerOrder(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrderList);
